export default __webpack_public_path__ + "3530bfc1b50b41bdc29dc4fa05741e32.ttf";